import { HavokPlugin } from "@babylonjs/core/Physics/v2/Plugins/havokPlugin";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Scene } from "@babylonjs/core/scene";
import HavokPhysics from '@babylonjs/havok'

export abstract class PhysicsHelper {

  public static async InitPhysics(scene: Scene) {
    const gravityVector = new Vector3(0, -9.81, 0)
    const havokInstance = await HavokPhysics()
    const havokPlugin = new HavokPlugin(true, havokInstance)
    scene.enablePhysics(gravityVector, havokPlugin)
  }

}